import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { isKiteUser } = {}) => ({
  button: {
    color: isKiteUser ? theme.palette.primary1 : theme.palette.pressed,
    fontWeight: isKiteUser ? '400' : '600',
    textDecoration: 'none',
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.1px',
    height: 36,
    width: 89,
    '&, &:hover': {
      backgroundColor: '#F4F4F4 !important',
      borderRadius: '20px',
    },
    [theme.breakpoints.down('md')]: {
      order: 0,
      width: 130,
      height: 34,
    },
  },
}));
